export default __webpack_public_path__ + "coin-10207faad7daba88b0a3a794569250d8.png";